import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from '../models/snitem';

@RegisterItem()
export class SNAgendaOpeningHour extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNAgendaOpeningHour';
    }

    public clone(): any {
        return new SNAgendaOpeningHour();
    }
}
